module.exports = __webpack_public_path__ + "labioplastika_10_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/labioplastika_10_before.jpg
// module id = 1064
// module chunks = 0